<div class="modal-header text-center" style="border-bottom: none">
  <h4>Are you sure?</h4>
  <p>
    You are about to add
    <strong>default folders</strong>
    to this client.<br />
    If you want to proceed, click add.
  </p>
</div>
<div class="modal-footer">
  <div
    class="btn btn-default pull-right"
    aria-label="Cancel"
    (click)="cancel()"
  >
    Cancel
  </div>
  <div
    class="btn btn-primary pull-left"
    aria-label="Confirm"
    (click)="confirm()"
  >
    Add
  </div>
</div>
